import { createOutlineIcon } from "../createIcon";

export const MessageCircleOutlineIcon = createOutlineIcon(
  <>
    <path d="M20.234 15.636A8.97 8.97 0 0 0 20.998 12 9 9 0 1 0 3 12a9 9 0 0 0 13.404 7.85L21 21l-.766-5.364Z" />
  </>,
  "MessageCircleOutlineIcon"
);
